import { useLocation, useSearchParams, Link, useLoaderData, Outlet } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import ServerFooter from "../common/ServerFooter";
import { Opportunity } from "./types";
//--------------------------------------------------------------------------------------------
export const extraFields = ["page", "limit"];
export default function OpportunityList(){
    const [searchParams, setSearchParams] = useSearchParams();
    const { opportunities, total }:{ opportunities: Opportunity[], total: number } = useLoaderData();
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;
    const noOrganizationAssociated = searchParams.get("noOrganizationAssociated") === "1";
    //--------------------------------------------------------------------------------------------
    return(
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <div className = "mt-2">
                <Link className = {"btn btn-outline-primary pointer position-relative"} to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.4em"}}/>:null}
                </Link>
                <Link children = "Export" className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}/>
                <input
                    type = "checkbox"
                    checked = {noOrganizationAssociated}
                    onChange = {e => {
                        const checked = e.currentTarget.checked;
                        const params = new URLSearchParams(searchParams);
                        if(checked) params.set("noOrganizationAssociated", "1");
                        else params.delete("noOrganizationAssociated");
                        setSearchParams(params, { replace: false });
                    }}
                    className = "cssCheckBox ms-3"
                />
                <label children = "No Organization Associated" htmlFor = "noOrg" className = "ms-2"/>
                <Link children = "Add" className = "btn btn-outline-primary float-end" to = "Add"/>
            </div>
            {!opportunities.length?<div className = "cssLoading">Empty</div>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Opportunity Name</th>
                            <th>Organization Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {opportunities.map((opportunity, key) => 
                        <tr key = {key}>
                            <td>{opportunity.opportunityName}</td>
                            <td>{opportunity.organizationName && <Link to = {`/Organizations/${opportunity.organizationId}`}>{opportunity.organizationName}</Link>}</td>
                            <td><Link children = "Detail" className = "btn btn-outline-primary" to = {String(opportunity.id)}/></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>}
            {total > 0? <ServerFooter length = {total}/> : null}
            <Outlet/>
        </div>
    )
}